export default __webpack_public_path__ + "5fef61dfe8cc801bec37cdef8aa33e75.png";